<div class="global-search-container">
	<div class="ui-g-12 no-padding text-center">
		<common-list
			[context]="commonListContext"
			[enabledFilters]="enabledFilters">
		</common-list>
	</div>
</div>